/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import { Box } from "@material-ui/core";

//custom libraries
import { LoginForm } from "../containers";
import { useCSRValue } from "../context";
import { Header } from "./../components";

export default function Dashboard() {
  const { csr } = useCSRValue();

  return (
    <Box display="flex" flexDirection="column" className="min-device-height">
      <Box>
        <Header shopAs={false} username={csr && csr.userLoggedIn} />
      </Box>

      <Box flexGrow={1}>
        {/* {csr && csr.userLoggedIn && <DashboardContent />} */}
        {(!csr || !csr.userLoggedIn) && <LoginForm />}
      </Box>
    </Box>
  );
}
